import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { CommonService, SsoService } from 'wire-frame';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Dr.Bhade Homeopathy Clinic';
  constructor(private common: CommonService, private sso: SsoService) { }
  ngOnInit() {
    try {
      this.common.isEmailadminLogin = true;
      this.common.setProductOwner('Dr. Subodh Bhade Clinic');
      this.common.setBaseUrl(environment.apiUrl + '/');
      this.sso.setLoginApiUrl(environment.apiUrl + '/login');
    } catch (e) { }
  }
}
